// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalDraft_modal__1n0Ki","showModal":"ModalDraft_showModal__tqW5a","outer":"ModalDraft_outer__SnPnd","close":"ModalDraft_close__3uDFd"};